import React from 'react';
import Heading from "../../common/header/Heading";
import VideoWithPlayButton from "../../ui/video/VideoWithPlayButton";
import AnimatedLink from "../../ui/motion/AnimatedLink";

export default function Presentation() {

    return (
        <div className="mw-md-3xl mx-auto">
            <Heading
                title='Jak wygląda Kurs od środka?'
                badgeText='Kurs efektywnego działania'
                // customSubtitleStyles='fs-9 fw-medium text-success'
                subtitle='Zobacz, jak dokładnie wygląda platforma szkoleniowa oraz struktura Kursu.'
            />
            <VideoWithPlayButton vimeoVideoId='1082463554' id='video-ked-showcase'/>
            <p className='text-white fw-medium mb-16'>Pełny opis każdego z tygodni Kursu znajdziesz <a
                className='text-success text-decoration-underline'
                href='https://docs.google.com/document/d/17eQ5cB8ZD7NsbcsHteTOztJVvydv4rPBPXL2dW2XeRI/edit?tab=t.0'>pod
                tym linkiem.</a></p>
            <hr className='text-white mb-10'/>

            <Heading
                title='Przykładowa lekcja'
                badgeText='Kurs efektywnego działania'
                subtitle='Obejrzyj przykładową lekcje z Kursu i zobacz, w jaki sposób jest ona prowadzona.'
            />
            <VideoWithPlayButton vimeoVideoId='1067621337' id='video-ked-lesson'/>

            <div className="row mt-12 justify-content-center">
                <div className="col-12 col-md-8 text-center">
                    <h3 className="fs-6 text-white mb-5">Wszystko jasne?</h3>
                    <AnimatedLink to="/newsletter/kurs-efektywnego-dzialania?source=ked-prezentacja"
                                  className="btn btn-lg btn-success">
                        Zapisz swoje dziecko już teraz
                    </AnimatedLink>
                </div>
            </div>
        </div>
    );
};
